export const MAINTENANCE_LIST_REQUEST = 'MAINTENANCE_LIST_REQUEST';

export const SET_MAINTENANCE_LIST = 'SET_MAINTENANCE_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_MAINTENANCE_PAGINATION = 'SET_MAINTENANCE_PAGINATION';

export const MAINTENANCE_TERMINATE = 'MAINTENANCE_TERMINATE';

export const MAINTENANCE_CREATE = 'MAINTENANCE_CREATE';

export const MAINTENANCE_DETAILS_REQUEST = 'MAINTENANCE_DETAILS_REQUEST';

export const SET_MAINTENANCE_DETAILS = 'SET_MAINTENANCE_DETAILS';

export const MAINTENANCE_REMOVE = 'MAINTENANCE_REMOVE';

export const MAINTENANCE_UPDATE = 'MAINTENANCE_UPDATE';

export const MAINTENANCE_RESPONSE = 'MAINTENANCE_RESPONSE';

export const RESET_MAINTENANCE_DETAILS = 'RESET_MAINTENANCE_DETAILS';
